/* PageSpeed mobile 24/09 nuit : au TÉLÉPHONE, tant que <html> porte `rv-att` (posée par la section, jamais à
   l'ordinateur), le corps du guide attend la fin du chargement ; ce script le mesure (tableaux, titres) et le
   forcerait à se mettre en page — il attend donc `lae:rv-libre`. Sans la classe, il part tout de suite, comme avant. */
(function(lance){ if(document.documentElement.classList.contains('rv-att')) document.addEventListener('lae:rv-libre',lance,{once:true}); else lance(); })(function(){
  var d=document;
  var corps=d.querySelector('.rv-corps');
  if(!corps) return;

  /* 1. Typographie française : une espace insécable avant « : ; ! ? » » et
        après « « ». Seuls des ESPACES changent — pas un mot, pas un signe. */
  (function(){
    var w=d.createTreeWalker(corps,NodeFilter.SHOW_TEXT,null),n,t,u;
    while((n=w.nextNode())){
      t=n.nodeValue;u=t.replace(/ ([:;!?\u00bb])/g,'\u00a0$1').replace(/\u00ab /g,'\u00ab\u00a0');
      if(u!==t) n.nodeValue=u;
    }
  })();

  /* 2. Photo en portrait : légende en regard (la hauteur déclarée en ligne
        est fausse, on lit la vraie une fois l'image chargée). */
  [].forEach.call(d.querySelectorAll('.lae-photo img'),function(im){
    function f(){if(im.naturalWidth&&im.naturalHeight>im.naturalWidth*1.08) im.closest('figure').classList.add('rv-portrait');}
    if(im.complete) f(); else im.addEventListener('load',f);
  });

  /* 3. Appels de notes : un lien du texte qui pointe vers une source déjà
        listée reçoit son numéro, relié à la note de fin. */
  var sources={},norm=function(h){return h.replace(/^http:/,'https:').replace(/\/+$/,'');};
  [].forEach.call(d.querySelectorAll('.lae-etudes > li'),function(li,i){
    li.id=li.id||('note-'+(i+1));
    var a=li.querySelector('a[href]'); if(a&&!sources[norm(a.href)]) sources[norm(a.href)]=i+1;
  });
  [].forEach.call(corps.querySelectorAll('a[href]'),function(a){
    if(a.closest('.rv-sec--src,.lae-etudes,.lae-fiche,.rv-appel')) return;
    var k=sources[norm(a.href)]; if(!k) return;
    var s=d.createElement('sup'); s.className='rv-appel'; s.setAttribute('data-interface','');
    s.innerHTML='<a href="#note-'+k+'" aria-label="Source '+k+'">'+k+'</a>';
    a.parentNode.insertBefore(s,a.nextSibling);
  });

  /* 3 bis. Tableaux de 3 colonnes ou plus : chaque cellule reçoit l'en-tête de
        sa colonne (data-label). Au téléphone, le CSS s'en sert pour poser le
        tableau en fiches. Rien n'est réécrit : on ajoute un attribut. */
  [].forEach.call(corps.querySelectorAll('table'),function(t){
    var th=[].map.call(t.querySelectorAll('thead th'),function(x){return x.textContent.trim();});
    if(th.length<3) return;
    [].forEach.call(t.querySelectorAll('tbody tr'),function(tr){
      [].forEach.call(tr.children,function(td,i){ if(th[i]) td.setAttribute('data-label',th[i]); });
    });
    t.classList.add('rv-empile');
  });

  /* 4. Tableau plus large que l'écran : on le dit, au-dessus du tableau. */
  var tabs=[].map.call(corps.querySelectorAll('table'),function(t){
    var p=d.createElement('p'); p.className='rv-glisser'; p.setAttribute('data-interface',''); p.setAttribute('aria-hidden','true');
    p.textContent='Faites glisser le tableau \u2192'; t.parentNode.insertBefore(p,t); return [t,p];
  });
  function deborde(){tabs.forEach(function(x){x[1].classList.toggle('rv-actif',x[0].scrollWidth>x[0].clientWidth+2);});}

  /* 4 bis. Copier le lien : le presse-papiers, et un retour lu par les
        lecteurs d'écran (role=status). Sans presse-papiers : on affiche l'URL. */
  [].forEach.call(d.querySelectorAll('[data-copier]'),function(b){
    b.addEventListener('click',function(){
      var ok=b.parentNode.querySelector('.rv-part__ok'),u=b.getAttribute('data-copier');
      var p=(navigator.clipboard&&navigator.clipboard.writeText)?navigator.clipboard.writeText(u):Promise.reject();
      p.then(function(){ok.textContent='Lien copié';setTimeout(function(){ok.textContent='';},3000);},
             function(){ok.textContent=u;});
    });
  });

  /* 5. Folio : la section courante, et la progression de lecture. */
  var folio=d.querySelector('.rv-folio'); if(!folio){deborde();return;}
  var num=folio.querySelector('.rv-folio__num'),tit=folio.querySelector('.rv-folio__t'),
      prog=folio.querySelector('.rv-folio__prog span'),lecture=d.querySelector('.rv-lecture'),
      liens=folio.querySelectorAll('.rv-folio__panneau a'),
      h2=[].slice.call(corps.querySelectorAll('.rv-sec > h2')),tit0=tit.textContent,cour=-2,rq=0;
  function maj(){
    rq=0;
    var seuil=folio.getBoundingClientRect().bottom+innerHeight*.28,i=-1;
    for(var k=0;k<h2.length;k++){ if(h2[k].getBoundingClientRect().top<seuil) i=k; else break; }
    if(i!==cour){
      cour=i;
      num.textContent=i<0?'':(h2[i].parentNode.getAttribute('data-num')||'');
      tit.textContent=i<0?tit0:h2[i].textContent;
      [].forEach.call(liens,function(l,k){ if(k===i) l.setAttribute('aria-current','true'); else l.removeAttribute('aria-current'); });
    }
    var r=lecture.getBoundingClientRect(),tot=Math.max(1,r.height-innerHeight);
    prog.style.transform='scaleX('+Math.min(1,Math.max(0,-r.top/tot)).toFixed(4)+')';
  }
  addEventListener('scroll',function(){ if(!rq) rq=requestAnimationFrame(maj); },{passive:true});
  addEventListener('resize',function(){ deborde(); maj(); });
  folio.querySelector('.rv-folio__panneau').addEventListener('click',function(ev){ if(ev.target.closest('a')) folio.open=false; });
  d.addEventListener('keydown',function(ev){ if(ev.key==='Escape'&&folio.open){ folio.open=false; folio.querySelector('summary').focus(); } });
  d.addEventListener('click',function(ev){ if(folio.open&&!folio.contains(ev.target)) folio.open=false; });
  deborde(); maj();
});
